import React from 'react';
import { executeGetDocsGroup } from '../../simbix/executer'

//Для выбранного элемента стиль должен быть current-path current-item current
const GroupItem = ({group, onChangeFolder}) => 
    <li style={{boxSizing: 'unset'}}>
        <span style={{boxSizing: 'unset', fontSize: "8px"}}>♦&nbsp;</span><a style={{boxSizing: 'unset'}} href="javascript:void(0)" onClick={()=> {onChangeFolder(group)}}>{group.NName}</a>
    </li>

class DocsGroup extends React.Component {	
    constructor(props, context) {
        super(props, context)
        const {filter, header, onSelectFolder} = props
        this.state = {
            loading: false, 			//Флаг загрузки
            filter: filter,
            header: (header)? header:"Файлы и документы",
            onSelectFolder:  onSelectFolder,
            groups: {},                 //Данные для отображения
        }
        this.onChangeFolder = this.onChangeFolder.bind(this);
    }

    componentWillMount() { 
        this.loadDocsGroup();
    }

    loadDocsGroup() {
        this.setState({loading: true})
        const condition = "ParId=1" + ((this.state.filter)? " and type='"+this.state.filter+"'":"")
        return executeGetDocsGroup({condition})
        .then ((response) =>{
            const {groups} = response
            console.log("loadDocsGroup", response)
            this.setState({loading: false, groups: groups.data});
            return Promise.resolve(response)
        })
        .catch(e => { 
            return Promise.reject(e);
        });
    }

    onChangeFolder(group) {        
        //console.log(`checked = ${group}`, group, this);
        const {onSelectFolder} = this.state;
        if (onSelectFolder) onSelectFolder(group);
    }

    render() {

        
        const {loading, groups, header } = this.state
        console.log(this)
        return (
            (loading? <div>Загрузка</div>:
                <div>
<ul className="main-menu" >
    <li className="current-path current-item current" >
        <div style={{boxSizing: 'unset'}}>{header}</div>
        <ul className="childs" >
            {groups.map((group, i) =>  
                <GroupItem key={i} 
                    group={group} 
                    onChangeFolder={this.onChangeFolder}/>
            )}
        </ul>
    </li>
</ul>

                </div>
            )
        )
    }
}

export default DocsGroup;